function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from "react";
import shortid from "shortid";
import styled from "styled-components";
import { GridRow, P } from "../../";
import { ReactComponent as StarIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!../../Icon/Indicator/Star.svg";
const Star = styled(StarIcon)`
  &:hover {
    path {
      stroke: #f69b2c;
    }
  }
  cursor: pointer;
  ${props => props.filled && `animation: starAnimation .2s;`}

  @keyframes starAnimation {
    0% {
      stroke: #f69b2c;
      stroke-width: 1;
    }

    50% {
      stroke: #f69b2c;
      stroke-width: 2;
    }

    100% {
      stroke: #f69b2c;
      stroke-width: 1;
    }
  }
`;
const StarBlank = styled(StarIcon)`
  path {
    fill: ${props => props.theme.colors.disabledFill};
  }
  &:hover {
    path {
      stroke: ${props => props.theme.colors.disabledFill};
      stroke-width: 1;
    }
  }
  cursor: pointer;
`;
export const Rating = ({
  max,
  value,
  setValue,
  ...props
}) => {
  const [bounce, setBounce] = useState(false);

  const getScale = () => {
    const newScale = [];

    for (let i = 0; i < max; i++) {
      newScale[i] = i < value ? Star : StarBlank;
    }

    return newScale;
  };

  const scale = getScale();

  const handleSelect = index => {
    setBounce(true);
    setValue(index + 1);
  };

  return React.createElement(IconsContainer, _extends({}, props, {
    yCenter: true,
    xCenter: true
  }), scale.map((Icon, index) => {
    return React.createElement(Icon, {
      key: shortid.generate(),
      filled: index <= value && bounce ? value : undefined,
      onClick: () => handleSelect(index),
      onAnimationEnd: () => setBounce(false)
    });
  }));
};
const IconsContainer = styled(GridRow)`
  justify-content: space-between;
`;